import Image from 'next/image'
import styled from 'styled-components'

export const ImageButton = styled(Image)`
  cursor: pointer;
  z-index: 1;
`
